import * as React from 'react'

import { Box, Line, Text } from '@factorialco/deprecated-design-system'
import ComputerCharts from 'assets/images/computer-charts-magnifying-glass.svg'

import i18n from 'modules/core/lib/i18n'

const BlankSlate = () => (
  <Box alignItems="center" textAlign="center" paddingY="s64">
    <Box gap="s16" alignItems="center">
      <img src={ComputerCharts} width={200} height={140} />

      <Box gap="s16" alignItems="center">
        <Text.Normal color="grey800">
          {i18n.t('competencies_v2.employees.empty_assessment')}
        </Text.Normal>
        <Line />
      </Box>
    </Box>
  </Box>
)

export default BlankSlate
